import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Environment } from 'src/environments/environment';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private apiUrl = Environment.apiUrl;
  constructor(private http: HttpClient, private router: Router) { }


  login(data: any) {
    this.logout();
    console.clear();
    return this.http.post(this.apiUrl + '/login', data);
  }

  loggedIn() {
    return !!localStorage.getItem('authorization');
  }
  
  getToken() {
    return localStorage.getItem('authorization');
  }

  logout() {
    localStorage.removeItem('authorization');
    localStorage.removeItem('name');
    localStorage.removeItem('lastName');
    localStorage.removeItem('email');
    this.router.navigate(['/login']);
  }
}
